<template>
    <div>
        <div class="g_restrict" v-if="edition && category">
            <div class="edition">
                <edition-banner :current="current" />
                <section-title />
                <section-branding
                    :category="category"
                    :header="edition.header"
                />
                <edition-header
                    :category="category"
                    :current="current"
                    :header="edition.header"
                />
                <edition-schedule
                    :category="category"
                    :schedule="edition.schedule"
                    :header="edition.header"
                />
                <edition-slider :key="current" :slides="edition.slides" />
                <edition-profile
                    :category="category"
                    :profile="edition.profile"
                />
            </div>
        </div>
        <slider-editions :current="current" :teasers="teasers" />
    </div>
</template>

<script>
import EditionBanner from '@/components/edition/EditionBanner'
import EditionHeader from '@/components/edition/EditionHeader'
import EditionProfile from '@/components/edition/EditionProfile'
import EditionSchedule from '@/components/edition/EditionSchedule'
import EditionSlider from '@/components/edition/EditionSlider'
import SectionBranding from '@/components/section/SectionBranding'
import SectionTitle from '@/components/section/SectionTitle'
import SliderEditions from '@/components/slider/SliderEditions'
import cleanUrl from '@/helpers/url'

export default {
    name: 'ViewEdition',
    components: {
        EditionBanner,
        EditionHeader,
        EditionProfile,
        EditionSchedule,
        EditionSlider,
        SectionBranding,
        SectionTitle,
        SliderEditions
    },
    data() {
        return {
            current: '',
            edition: {
                category: ''
            },
            isPreview: false
        }
    },
    computed: {
        teasers() {
            return this.$json.editions.reduce((editions, edition) => {
                if (this.isPublished(edition)) {
                    const teaser = {
                        ...edition.teaser,
                        color: this.categories[edition.category].color,
                        number: edition.number
                    }
                    editions.push(teaser)
                }
                return editions
            }, [])
        },
        category() {
            return this.categories[this.edition.category]
        },
        categories() {
            return this.$json.config.categories
        }
    },
    watch: {
        $route: {
            handler(to) {
                this.setPreview(to.query)
                this.setCurrent(to.params)
            },
            immediate: true
        },
        current: {
            handler(number) {
                this.loadEdition(number)
            },
            immediate: true
        }
    },
    methods: {
        setPreview({ ispreview = undefined }) {
            this.isPreview = ispreview !== undefined
        },
        setCurrent({ edition = '' }) {
            this.current = edition
        },
        setDefault() {
            const flippedEditions = [...this.$json.editions].reverse()
            const latest = flippedEditions.find(this.isPublished.bind(this))
            const title =
                latest.header.title && latest.header ? latest.header.title : ''

            this.redirectEdition(latest.number, title)
        },
        loadEdition(number) {
            const edition = this.$json.editions.find(
                edition => edition.number === number
            )
            if (!this.isVisible(edition)) {
                this.setDefault()
            } else {
                this.edition = edition
            }
        },
        isPublished(edition) {
            const { publish } = edition
            const dateInRange = Date.now() > Date.parse(publish.date)
            return publish.status === true && dateInRange
        },
        isVisible(edition) {
            const isPublished = edition && this.isPublished(edition)
            const isVisible = isPublished || (!isPublished && this.isPreview)
            return isVisible
        },
        redirectEdition(edition, title) {
            const language =
                this.$Landing && this.$Landing.language
                    ? this.$Landing.language
                    : 'EN'
            this.$router.push({
                name: 'edition',
                params: { edition, language, title: cleanUrl(title) }
            })
        }
    }
}
</script>

<style lang="sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import ~gvue/src/core/Zone/sass/zone/zone

.edition
    position: relative
    z-index: 0
    display: grid
    grid-template-columns: 27vw 73vw
    grid-template-rows: ($section_padding * 1.5) auto auto auto 1fr auto
.banner
    grid-area: 1 / 1 / 2 / 3
.title
    grid-area: 2 / 1 / 5 / 2
.branding
    grid-area: 2 / 2 / 3 / 3
.header
    grid-area: 3 / 2 / 4 / 3
.schedule
    grid-area: 4 / 2 / 5 / 3
.slider
    grid-area: 5 / 1 / 6 / 3
.profile
    grid-area: 6 / 2 / 7 / 3

+mobile
    .g
        .g_restrict
            padding: 0

+desktop
    .edition
        grid-template-columns: 33% 12% 55%
        grid-template-rows: 1fr auto auto auto
    .branding
        grid-area: 1 / 1 / 2 / 2
    .banner
        grid-area: 1 / 3 / 2 / 4
    .title
        grid-area: 1 / 2 / 2 / 3
    .schedule
        grid-area: 2 / 1 / 3 / 3
    .header
        grid-area: 2 / 3 / 4 / 4
    .slider
        grid-area: 3 / 1 / 5 / 3
    .profile
        grid-area: 4 / 3 / 5 / 4
</style>
